module.exports = __webpack_public_path__ + "img/lady2.c576dd02.png";